import { FC } from "react";
import LoadingSpinner from "./LoadingSpinner";

export const RoutePending: FC = () => {
  return (
    <div className="flex min-h-64 flex-1 items-center justify-center">
      <LoadingSpinner size="64px" />
    </div>
  );
};
